export const Runway = [
    {
        runwayImg:'https://www.foldnfly.com/images/tips/ruler.webp',
        title:'Crisp Folds',
        info:'Using a ruler can help you make accurate folds that are straight and accurate. You also want crisp, sharp folds. Use your fingernail, or get a bone folding tool to make it easier.'
    },
    {
        runwayImg:'https://www.foldnfly.com/images/tips/symmetry.webp',
        title:'Symmetry',
        info:'Symmetry is when both halves are the same. This is very important when folding paper airplanes because even the slightest asymmetry can cause the airplane to spin out of control. Make sure the left and right sides both look exactly the same.'
    },
    {
        runwayImg:'https://www.foldnfly.com/images/tips/tape.webp',
        title:'Tape',
        info:'Sometimes a paper airplane can be improved by using a little tape to keep the body of the airplane from unfolding mid-flight. You can also use a staple for the same purpose, but it will add a little extra weight.'
    },
    {
        runwayImg:'https://www.foldnfly.com/images/tips/weight.webp',
        title:'Paper Clips',
        info:'The center of mass is where the paper plane balances from front to back. If the center of mass is too far forwards, the paper airplane will dive. Too far back and it will rise and stall. Try using a small paper clip, or staple, to adjust the center of mass to your liking.'
    },
    {
        runwayImg:'https://www.foldnfly.com/images/tips/width.webp',
        title:'Skinny or Wide',
        info:'In general, paper planes with wider wings will be slower and glide better. Airplanes with skinny wings will go faster and further.'
    },
    {
        runwayImg:'https://www.foldnfly.com/images/tips/mistakes.webp',
        title:'Mistakes',
        info:"Mistakes are just another way of learning what works. If you make a mistake, it's better to start over with a fresh piece of paper than to end up with an airplane that has a messy or unfolded crease."
    },
    {
        runwayImg:'https://www.foldnfly.com/images/tips/aileron.webp',
        title:'Aileron/Elevator Adjustments',
        info:"The back of the wings can be adjusted to steer your paper airplane. Bend the wings down to make the airplane dive and bend the wings up to make the airplane climb. Bend one up and one down to make the airplane spin. Small adjustments make a big difference."
    },
    {
        runwayImg:'https://www.foldnfly.com/images/tips/rudder.webp',
        title:'Rudder Adjustments',
        info:"Bend the vertical tail of the paper airplane to steer it left or right. Bend the tail in the direction that you want the nose of the airplane to go. Use very small adjustments."
    },
    {
        runwayImg:'https://www.foldnfly.com/images/tips/force.webp',
        title:'Throw Force',
        info:"Some paper airplanes designs like being thrown hard and fast. Other designs prefer a light toss. Experiment to find out what works best for your paper airplane."
    },
    {
        runwayImg:'https://www.foldnfly.com/images/tips/airplane.webp',
        title:'Angle',
        info:"Most paper airplanes work best when thrown level or slightly upwards, but some acrobatic designs work best with thrown slightly downwards or straight up. Experiment to discover what works best."
    },
    {
        runwayImg:'https://www.foldnfly.com/images/tips/wind.webp',
        title:'Wind',
        info:"When flying outdoors use the wind in your favor. Throwing into the wind works well for glider and acrobatic type airplanes. For speed and distance throw with the wind. Try throwing at right angles the wind to see what happens!"
    },
    {
        runwayImg:'https://www.foldnfly.com/images/tips/paper.webp',
        title:'Paper',
        info:"Try experimenting with different sizes and types of paper. Some airplanes work best when made with smaller sized paper, others may work best with heavier cardstock."
    },
]